export { default as DoorContent } from './door-content';
